import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;


const readQuestionaireData = `${API_URL}/api/questionnaire/get`;
const readQuestionaireDataList= `${API_URL}/api/questionnaire/get/list`;
const readQuestionaireById = `${API_URL}/api/questionnaire/getbyid/`;
const createQuestionaire = `${API_URL}/api/questionnaire/create`;
const updateQuestionaire = `${API_URL}/api/questionnaire/update`;
const deleteQuestionaire = `${API_URL}/api/questionnaire/delete/`;
const readLanguageData = `${API_URL}/language-supported/getAll`;




export function ReadQuestionaireData() {
  return axios.get(readQuestionaireData);
}

export function ReadQuestionaireDataList() {
  return axios.get(readQuestionaireDataList);
}

export function ReadQuestionaireById(id: string) {
  return axios.get(readQuestionaireById + id);
}

export function CreateQuestionaire(questionaire: any) {
  return axios.post(createQuestionaire, questionaire);
}

export function DuplicateQuestionaire(id: string) {
  return axios.post(`${API_URL}/api/questionnaire/duplicate/${id}`);
}

export function UpdateQuestionaire(id: string, questionaire: any) {
  return axios.put(`${updateQuestionaire}/${id}`, questionaire);
}

export function DeleteQuestionaire(id: string) {
  return axios.delete(deleteQuestionaire + id);
}

export function ReadLanguageData() {
  return axios.get(readLanguageData);
}

export function GetDeletedQuestionnaires() {
  return axios.get(`${API_URL}/api/questionnaire/deleted`);
}

export function RestoreQuestionnaire(id: any) {
  return axios.put(`${API_URL}/api/questionnaire/restore/${id}`);
}

export function PermanentDeleteQuestionnaire(id: any) {
  return axios.delete(`${API_URL}/api/questionnaire/permanent-delete/${id}`);
}
